import React from "react";
import "./Credentials.css";

const Credentials = () => {
  return (
    <div className="credentials-container">
      {/* Header Section */}
      <header className="credentials-header">
        <h1>Our Credentials & Certifications</h1>
      </header>

      {/* Official License Section */}
      <div className="credential-container">
        {/* License Section - Left */}
        <section className="license-section">
          <h2>Official License for Motor Driving School</h2>
          <img
            src="/images/cred1.jpg"
            alt="Official License Certificate"
            className="certificate-image"
          />
          <p>
            We are proud to announce that{" "}
            <strong>Vahan Chaalak Kaushal Vikas Sansthan</strong>, located at
            NH-48, Singawal, District Ajmer, Rajasthan, is officially licensed
            under the Central Motor Vehicle Act, 1988, and the Central Motor
            Vehicle Rules, 1989.
          </p>
          <ul>
            <li>
              <strong>License Number:</strong> RJ 01/9*
            </li>
            <li>
              <strong>Date of Issue:</strong> 15th January 2024
            </li>
            <li>
              <strong>Valid Until:</strong> 14th January 2029
            </li>
            <li>
              <strong>Approved by:</strong> Licensing Authority, Ajmer,
              Rajasthan
            </li>
            <li>
              <strong>Authorized Training Vehicles:</strong> RJ01XX 0015,
              RJ06TA2725
            </li>
          </ul>
          <p>
            As a government-recognized motor driving school, we are committed to
            providing high-quality driver training.
          </p>
        </section>

        {/* Certificate Section - Right */}
        <section className="certificate-section">
          <h3>Certificate of Appreciation</h3>
          <h4>Independence Day Ceremony 2024</h4>
          <img
            src="/images/c2.png"
            alt="Certificate of Appreciation - 2024"
            className="certificate-image"
          />
          <br />
          <br />
          <br />
          <p>📜 <em>Awarded by District Administration, Ajmer</em></p>
          <br />
          <p>
            🏆 We are honored to receive this{" "}
            <strong>Certificate of Appreciation</strong> from the{" "}
            <strong>District Administration, Ajmer</strong>, in recognition of
            our contributions during the{" "}
            <strong>Independence Day Ceremony – 2024</strong>.
          </p>
          <ul>
            <li>
              <strong>Award Date:</strong> 15th August 2024
            </li>
            <li>
              <strong>Presented To:</strong> Vahan Chaalak Kaushal Vikas
              Sansthan, Singawal
            </li>
          </ul>
          <p>
            This recognition highlights our commitment to excellence in driving
            training and skill development.
          </p>
        </section>
      </div>

{/* Testimonials & Reviews Section */}
<section className="testimonials-section">
  <h2>Testimonials & Reviews</h2>
  <div className="testimonials-grid">
    
    <div className="testimonial-card">
      <p>
        “Facilities are well-maintained and fully equipped for training.
        Hospitality of the staff is excellent. We would love to
        collaborate again in future.”
      </p>
      <h4>- Women Entrepreneurship Organization</h4>
      <span>Visit Date: 21/06/2024</span>
    </div>

    <div className="testimonial-card">
      <p>
        “Training operations and management here are highly commendable.
        Great efforts toward road safety and skill development.”
      </p>
      <h4>- Government Training Inspector</h4>
      <span>Visit Date: 20/06/2025</span>
    </div>

    <div className="testimonial-card">
      <p>
        “This center is very helpful for learners. The disciplined environment
        helps trainees gain great confidence.”
      </p>
      <h4>- Skill Verification Observer</h4>
      <span>Visit Date: 19/02/2024</span>
    </div>

    <div className="testimonial-card">
      <p>
        “Excellent training standards with dedicated instructors. Wishing the team
        continued success!”
      </p>
      <h4>- Training & Development Guest</h4>
      <span>Visit Date: 18/02/2024</span>
    </div>

  </div>
</section>

    </div>
  );
};

export default Credentials;
